function updateCartSummaries(showCartSummary) {
    $.get('/search', function(data){
      var selectors = ['.toolbar-cart', '#cart-summary'];
      var $parsed = $($.parseHTML('<div>' + data + '</div>'));
      for(var i=0; i<selectors.length; i++) {
        var cartSummarySelector = selectors[i];
        var $newCartObj = $parsed.find(cartSummarySelector).clone();
        var $currCart = $(cartSummarySelector);
        $currCart.replaceWith($newCartObj);
      }
      var pagePath = window.location.pathname;
      if (pagePath == "/cart") {
          location = location;
      }
      document.querySelector(".free-gift-sticky-btn-wrapper") ? handleFreeGiftChangesOnCartUpdate() : null;
    });
}function addToCart(clickedBtn, variantID, qty, origBtnText) {
    var thisBtn = clickedBtn;
    // set all json values that need to be passed
    var params = {
        id: variantID,
        quantity: qty
    }
    var thisBtnClass = checkButtonClass(thisBtn);
    // make the request
    var addRequest = new XMLHttpRequest();
    addRequest.open('POST', '/cart/add.js')
    addRequest.setRequestHeader('Content-Type', 'application/json')
    addRequest.send(JSON.stringify(params))
    addRequest.onload = function() {
        var postResponse =  JSON.parse(addRequest.response);
        theme.createCookie('theme_added_to_cart','justnow',1);
          if(typeof theme.readCookie('theme_added_to_cart') != 'undefined' && theme.readCookie('theme_added_to_cart') == 'justnow') {
            theme.eraseCookie('theme_added_to_cart');
            updateCartSummaries(false);
          }
        setTimeout(function() {
          $(thisBtn).text(origBtnText);
          if ((thisBtn.hasClass("open-cart") && !($("body").hasClass("show-cart-summary"))) || (thisBtn.closest(".flex.column").hasClass("product-block") && !($("body").hasClass("show-cart-summary")))) {
            if (thisBtn.hasClass("accept-offer")) {
              var copyElement = thisBtn.closest(".quick-offer__wrapper").find(".quick-offer__copy");
              var thankYouMsgElement = thisBtn.closest(".quick-offer__wrapper").find(".quick-offer__thank-you-msg").text();
              copyElement.animate({
                opacity: 0
              }, 10, function() {
                copyElement.text(thankYouMsgElement).delay(100).animate({
                  opacity: 1
                }, 100);
              });
              hideQuickOfferAndSetCookie(thisBtn, ".gg-content-area", 1500);
              setTimeout(function() {
                $(".current-cart").click();
                // 
                fixedNavWebkitHack();
              }, 2000);
            }
            else {
              $(".current-cart").click();
              // 
              fixedNavWebkitHack();
            }
          }
          if (thisBtnClass != ".promo-add") {
            $(thisBtnClass).removeAttr('disabled');
          }
        }, 2000);
    }
}
function checkButtonClass(buttonElement) {
  if ($(buttonElement).hasClass("decline-offer")) {
    var buttonClass = ".decline-offer";
    return buttonClass;
  }
  else if ($(buttonElement).hasClass("gg-dynamic-cart-ad__btn")) {
    var buttonClass = ".gg-dynamic-cart-ad__btn";
    return buttonClass;
  }
  else if ($(buttonElement).hasClass("gg-quick-add-btn")) {
    var buttonClass = ".gg-quick-add-btn";
    return buttonClass;
  }
  else if ($(buttonElement).hasClass("promo-add")) {
    var buttonClass = ".promo-add";
    return buttonClass;
  }
  else {
    return "no identified class";
  }
}
function getQuickAddVariantID(clickedButton) {
  if (clickedButton.attr("data-variant-id") != null) {var currentVariantID = clickedButton.attr("data-variant-id");
  }
  else if (clickedButton.closest(".product-form").find(".option-selectors").length) {var currentVariantID = clickedButton.closest(".product-form").find(".original-selector").val();
  }
  else {var currentVariantID = clickedButton.closest(".product-form").find("input[name='id']").val();
  }
  return currentVariantID;
}
function hideQuickOfferAndSetCookie(clickedButton, closestElementSelector, delayInMilliseconds) {
  var parentContentArea = clickedButton.closest(closestElementSelector);
  setTimeout(function(){
    parentContentArea.slideUp();
    setCookie(quickOfferObj.cookieName, quickOfferObj.viewLimit + 1, quickOfferObj.cookieExpDays);
  }, delayInMilliseconds);
}
function checkCurrentURLForOfferProduct() {
  var isSameProduct = false;
  var productHandle = window.location.href;var quickOfferHref = $(".quick-offer__copy a").attr("href");

  if (productHandle.indexOf("?") > -1) {
    productHandle = productHandle.split("?")[0].split("/");
  }
  else {
    productHandle = productHandle.split("/");
  }
  productHandle = productHandle[productHandle.length - 1];if (quickOfferHref) {
    if (quickOfferHref.indexOf("?") > -1) {
      quickOfferHref = quickOfferHref.split("?")[0].split("/");
    }
    else {
      quickOfferHref = quickOfferHref.split("/");
    }
    quickOfferHref = quickOfferHref[quickOfferHref.length - 1];
    if (productHandle == quickOfferHref) {isSameProduct = true;
      return isSameProduct;
    }
    else {return isSameProduct;
    }
  }
}$(function() {
  quickOfferObj = {
    cookieName: "ggQuickOffer",
    cookieValue: 1,
    cookieExpDays: 1,
    viewLimit: 100
  }
  if ($(".quick-offer__wrapper").length) {
    var sameProduct = checkCurrentURLForOfferProduct();
    var quickOfferCookieVal = parseInt(getCookie(quickOfferObj.cookieName));if (parseInt(quickOfferCookieVal) <= quickOfferObj.viewLimit) {
      if(!sameProduct) {setCookie(quickOfferObj.cookieName, quickOfferCookieVal + 1, quickOfferObj.cookieExpDays);
        $(".quick-offer__wrapper").removeClass("hidden");
      }
    }
    else if (isNaN(quickOfferCookieVal) || quickOfferCookieVal == "" || quickOfferCookieVal == null || quickOfferCookieVal == undefined) {
      if(!sameProduct) {
        setCookie(quickOfferObj.cookieName, quickOfferObj.cookieValue, quickOfferObj.cookieExpDays);
        $(".quick-offer__wrapper").removeClass("hidden");
      }
    }
  }
});$(document).on("click", "button", function(){
    var thisBtn = $(this);
    var originalText = thisBtn.text();
    var thisBtnClass = checkButtonClass(thisBtn);

    if (thisBtnClass != "no identified class" && thisBtnClass != ".decline-offer") {
      thisBtn.text("Adding to cart…");
      $(thisBtnClass).attr("disabled","disabled");
      var currentVariantID = getQuickAddVariantID(thisBtn);
      if (currentVariantID != null || currentVariantID != undefined) {
        addToCart(thisBtn, currentVariantID, 1, originalText);
      }
    }
    else if (thisBtnClass == ".decline-offer") {
      var parentContentArea = thisBtn.closest(".gg-content-area");
      hideQuickOfferAndSetCookie(thisBtn, ".gg-content-area", 250);
    }
});$(document).on("click", ".cart-summary-item .remove", function(event) {
    clicked_line_item = $(this).parents(".cart-summary-item");
    $(clicked_line_item).prepend("<div class='remove-item-spinner'></div>");
    clicked_line_item_input = $(clicked_line_item).find(".qty input");
    $(clicked_line_item_input).val("0").attr("value","0").change();
    event.preventDefault();
});function handleGiftMsgToggle() {
  if ($(".cart-summary__include-gift-msg__checkbox").is(":checked")) {
    $(".cart-summary-buttons .btn.checkout").attr("href", "/cart");
  } else if (!$(".cart-summary__include-gift-msg__checkbox").is(":checked")) {
    $(".cart-summary-buttons .btn.checkout").attr("href", "/checkout");
  }
}
$(document).on("click", ".cart-summary__include-gift-msg__label", function() {
  handleGiftMsgToggle();
});
$(function() {
  waitForElement(".cart-summary__include-gift-msg__checkbox", function() {
    $.getJSON('/cart.js', function(cart) {
      if (cart.attributes.Gift_Message) {
        $(".cart-summary__include-gift-msg__checkbox").click();
      }
    });
    handleGiftMsgToggle();
  });
})